module.exports = __webpack_public_path__ + "7426e563ffc2ce854c2fc9bb8752255b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/banner2.png
// module id = 691
// module chunks = 54 55 56 79 80 88